// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2355":"32bb83b3","2886":"b7f75fbf","4020":"7af7371b","4103":"a2a075cf","4218":"5522907e","5237":"4b12b862","5568":"ad290dc5","6556":"4dcfc121","7802":"f6626a59","8091":"b90fc591"}[chunkId] + ".chunk.css";
};